import React , {useState} from "react"
import Footer from "./footer";
import Navbar from "./navbar";
import "../css/profilePage.css"
import baseUrl from "../base_url";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";

function UserProfile({name}){
    return(
        <div className="userProfile">
            <div className="welcomeUser">
                <p>Hello <span className="userName">{name}</span></p>
                <p className="smallerText">Hope you are doing Fine !!!</p>
            </div>
        </div>
    )
}

function Offer({image , heading ,type, details}){
    return(
        <div className="offer">
            <div className="offer_img">
                <img src={image} alt="offer_image"></img>
            </div>
            <div className="offer_details">
                <h5>{heading}</h5>
                <p>{type}</p>
                <p>{details}</p>
            </div>
        </div>
    )
}

function SectionOne({userData}){
    return(
        <div className="SectionOne">
            <div className="UserProfileArea">
                <UserProfile
                    name = {userData.firstName}
                />
            </div>
            <div className="UserOffers">
                <span><h4>My Offers</h4></span>
                <span className="row offers_area">
                    <Offer
                        image = "https://lp2.hm.com/hmgoepprod?source=url[https://www2.hm.com/content/dam/Hm_Member_and_Loyalty/seasonal-images-loyalty/6010/6010_110_3x2.jpg]&scale=size[150]&sink=format[jpeg],quality[80]" 
                        heading = "10% off your entire purchase"
                        type = "Welcome Offer"
                        details = "Valid Till : 25/12/25"
                    />
                    <Offer
                        image = "https://lp2.hm.com/hmgoepprod?source=url[https://www2.hm.com/content/dam/Hm_Member_and_Loyalty/percentage-images/8103-Member-Percent-20-3x2-01.jpg]&scale=size[150]&sink=format[jpeg],quality[80]" 
                        heading = "20% off Home purchases"
                        type = "Voucher"
                        details = "Valid Till : 1/1/25"
                    />
                    <Offer
                        image = "https://lp2.hm.com/hmgoepprod?source=url[https://www2.hm.com/content/dam/Hm_Member_and_Loyalty/cms/2024/october/spotifypremium_reward_3x2.jpg]&scale=size[150]&sink=format[jpeg],quality[80]" 
                        heading = "For Members who Love Music"
                        type = "Promotion"
                        details = "Valid Till : 4/10/25"
                    />

                </span>
            </div>
        </div>
    )
}

const SettingOption  = (props)=>{

    function handleClick(){
        props.setStep(props.step)
    }

    return(
        <div onClick={handleClick} className="settingsSetting">
            <i class={props.iconClass}></i>
            <p>{props.Setting}</p>
            <i class="fa-solid fa-chevron-right"></i>
        </div>   
    )
}

function Orders(){
    return(
        <div className="SettingAreaDiv OrdersDiv">
            <h5>All purchases</h5>
            <Link to="/orders">View All Purchases <i class="fa-light fa-arrow-right-from-bracket"></i></Link>
        </div>
    )
}

const AddressParticular = ({ address, isEditing, editedValues, handleChange, index }) => {
    if (isEditing) {
        return (
            <div className="addressParticular w-full h-auto bg-[#FAF9F8] flex flex-col gap-[5px] pb-[5px] pl-[5px] border rounded mb-4">
                <span>
                    <p>Full Name</p>
                    <input 
                        type="text" 
                        name="fullName" 
                        value={editedValues.addresses[index]?.fullName || ''} 
                        onChange={(e) => handleChange('addresses', index, 'fullName', e.target.value)} 
                        className="userData p-1 border rounded"
                    />
                </span>

                <span>
                    <p>Flat/House/Apartment</p>
                    <input 
                        name="houseNumber" 
                        onChange={(e) => handleChange('addresses', index, 'houseNumber', e.target.value)}
                        value={editedValues.addresses[index]?.houseNumber || ''}
                        className="userData p-1 border rounded"
                    />
                </span>

                <span>
                    <p>Area</p>
                    <input 
                        type="text" 
                        name="streetAddress" 
                        value={editedValues.addresses[index]?.streetAddress || ''} 
                        onChange={(e) => handleChange('addresses', index, 'streetAddress', e.target.value)} 
                        className="userData p-1 border rounded"
                    />
                </span>

                <span>
                    <p>City</p>
                    <input 
                        type="text" 
                        name="city" 
                        value={editedValues.addresses[index]?.city || ''} 
                        onChange={(e) => handleChange('addresses', index, 'city', e.target.value)} 
                        className="userData p-1 border rounded"
                    />
                </span>

                <span>
                    <p>Postal Code</p>
                    <input 
                        type="text" 
                        name="postalCode" 
                        value={editedValues.addresses[index]?.postalCode || ''} 
                        onChange={(e) => handleChange('addresses', index, 'postalCode', e.target.value)} 
                        className="userData p-1 border rounded"
                    />
                </span>

                <span>
                    <p>State</p>
                    <input 
                        type="text" 
                        name="state" 
                        value={editedValues.addresses[index]?.state || ''} 
                        onChange={(e) => handleChange('addresses', index, 'state', e.target.value)} 
                        className="userData p-1 border rounded"
                    />
                </span>

                <span>
                    <p>Phone No.</p>
                    <input 
                        type="text" 
                        name="phone" 
                        value={editedValues.addresses[index]?.phone || ''} 
                        onChange={(e) => handleChange('addresses', index, 'phone', e.target.value)}
                        className="userData p-1 border rounded" 
                    />
                </span>

                <input 
                    type="hidden" 
                    name="country" 
                    value={editedValues.addresses[index]?.country || 'India'}
                />
            </div>
        )
    }
    
    return (
        <div className="addressParticular w-full h-auto bg-[#FAF9F8] flex flex-col gap-[5px] pb-[5px] pl-[5px] border rounded mb-4">
            <span>
                <p>Full Name</p>
                <p className="userData">{address.fullName}</p>                    
            </span>

            {address.houseNumber && (
                <span>
                    <p>Flat/House/Apartment</p>
                    <p className="userData">{address.houseNumber}</p>                    
                </span>
            )}

            <span>
                <p>Address</p>
                <p className="userData">{address.streetAddress}</p>                    
            </span>

            <span>
                <p>City</p>
                <p className="userData">{address.city}</p>                    
            </span>

            <span>
                <p>Postal Code</p>
                <p className="userData">{address.postalCode}</p>                    
            </span>

            <span>
                <p>State</p>
                <p className="userData">{address.state}</p>                    
            </span>

            <span>
                <p>Phone No.</p>
                <p className="userData">{address.phone}</p>                    
            </span>
        </div>
    )
}

const PaymentParticular = ({ method }) => {
    const cardN = method.cardNumber;
    const cleanedCardN = cardN.replace(/\s+/g, '');

    let hiddenCard = "";
    for (let i = 0; i < cleanedCardN.length + 2; i++) {
        if (i % 5 === 4) {
            hiddenCard += " ";
        } else if (i < 10) {
            hiddenCard += 'x';
        } else {
            hiddenCard += cleanedCardN[i - Math.floor(i / 5)];
        }
    }

    return (
        <div className="addressParticular w-full h-auto bg-[#FAF9F8] flex flex-col gap-[5px] pb-[5px] pl-[5px]">
            <span>
                <p>Card Name</p>
                <p className="userData">{method.cardName}</p>                    
            </span>

            <span>
                <p>Card Number</p>
                <p className="userData">{hiddenCard}</p>                    
            </span>
        </div>
    )
}

function AccountSettings({ userData, setUserData }) {
    const [isEditing, setIsEditing] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [editedValues, setEditedValues] = useState({
        firstName: userData?.firstName || '',
        lastName: userData?.lastName || '',
        phoneNumber: userData?.phoneNumber || '',
        email: userData?.email || '',
        dob: userData?.dob || '',
        addresses: userData?.address && userData.address.length > 0 
            ? [...userData.address] 
            : []
    });

    // Create empty address template
    const emptyAddress = {
        fullName: '',
        phone: '',
        houseNumber: '',
        streetAddress: '',
        city: '',
        state: '',
        postalCode: '',
        country: 'India'
    };

    // Handle change for nested fields (address items)
    const handleChange = (field, index, subfield, value) => {
        if (field === 'addresses' && subfield) {
            setEditedValues(prev => {
                const updatedAddresses = [...prev.addresses];
                if (!updatedAddresses[index]) {
                    updatedAddresses[index] = { ...emptyAddress };
                }
                updatedAddresses[index] = {
                    ...updatedAddresses[index],
                    [subfield]: value
                };
                return {
                    ...prev,
                    addresses: updatedAddresses
                };
            });
        } else {
            setEditedValues(prev => ({
                ...prev,
                [field]: value
            }));
        }
    };

    const handleEditToggle = () => {
        if (isEditing) {
            // Cancel edit - reset values
            setEditedValues({
                firstName: userData?.firstName || '',
                lastName: userData?.lastName || '',
                phoneNumber: userData?.phoneNumber || '',
                email: userData?.email || '',
                dob: userData?.dob || '',
                addresses: userData?.address && userData.address.length > 0 
                    ? [...userData.address] 
                    : []
            });
        }
        setIsEditing(!isEditing);
        setError(null);
    };

    const handleAddNewAddress = () => {
        setEditedValues(prev => ({
            ...prev,
            addresses: [...prev.addresses, { ...emptyAddress }]
        }));
    };

    const handleRemoveAddress = (index) => {
        setEditedValues(prev => {
            const updatedAddresses = [...prev.addresses];
            updatedAddresses.splice(index, 1);
            return {
                ...prev,
                addresses: updatedAddresses
            };
        });
    };

    const handleSubmit = async () => {
        try {
            setIsLoading(true);
            setError(null);

            // Validate addresses before submission
            const validAddresses = editedValues.addresses.filter(addr => 
                addr.fullName && addr.phone && addr.streetAddress && 
                addr.city && addr.state && addr.postalCode
            );

            // Prepare data for submission
            const dataToSubmit = {
                ...editedValues,
                address: validAddresses
            };
            
            // Remove addresses from the payload as we're using address in the backend
            delete dataToSubmit.addresses;

            console.log("Submitting data:", dataToSubmit);
            
            const response = await axios.post(
                `${baseUrl}api/user/profile/update`, 
                dataToSubmit, 
                { withCredentials: true }
            );
            
            if (response.data.success) {
                // Update the userData in the parent component to reflect changes
                setUserData(prevData => ({
                    ...prevData,
                    ...response.data.data
                }));
                setIsEditing(false);
            }
        } catch (err) {
            console.error("Error updating profile:", err.response?.data || err.message);
            setError(err.response?.data?.message || "Failed to update profile");
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="SettingAreaDiv">
            <div className="AccountSettingsDiv flex flex-col">
                <div className="flex justify-between items-center mb-4">
                    <div>
                        <h2>Account Settings</h2>
                    </div>
                    <button 
                        onClick={handleEditToggle}
                        className={`px-4 py-2 rounded ${isEditing ? 'bg-red-500 text-white' : 'bg-blue-500 text-white'}`}
                    >
                        {isEditing ? 'Cancel' : 'Edit Profile'}
                    </button>
                </div>

                {error && <div className="text-red-500 mb-4 p-2 bg-red-100 rounded">{error}</div>}

                <div className="account_settings_user_info mb-5 pl-[5px]">
                    <h4>My details</h4>

                    <span>
                        <p>My email</p>
                            <p className="userData">{userData?.email}</p>
                    </span>

                    <span>
                        <p>First Name</p>
                        {isEditing ? (
                            <input 
                                type="text" 
                                value={editedValues.firstName} 
                                onChange={(e) => handleChange('firstName', null, null, e.target.value)} 
                                className="userData p-1 border rounded"
                            />
                        ) : (
                            <p className="userData">{userData?.firstName}</p>
                        )}
                    </span>
        
                    <span>
                        <p>Last Name</p>
                        {isEditing ? (
                            <input 
                                type="text" 
                                value={editedValues.lastName} 
                                onChange={(e) => handleChange('lastName', null, null, e.target.value)} 
                                className="userData p-1 border rounded"
                            />
                        ) : (
                            <p className="userData">{userData?.lastName}</p>
                        )}
                    </span>

                    <span>
                        <p>Phone Number</p>
                        {isEditing ? (
                            <input 
                                type="tel" 
                                value={editedValues.phoneNumber} 
                                onChange={(e) => handleChange('phoneNumber', null, null, e.target.value)} 
                                className="userData p-1 border rounded"
                            />
                        ) : (
                            <p className="userData">{userData?.phoneNumber}</p>
                        )}
                    </span>

                    <span>
                        <p>Birthday</p>
                        {isEditing ? (
                            <input 
                                type="date" 
                                value={editedValues.dob} 
                                onChange={(e) => handleChange('dob', null, null, e.target.value)} 
                                className="userData p-1 border rounded"
                            />
                        ) : (
                            <p className="userData">{userData?.dob}</p>
                        )}
                    </span>
                </div>

                <div className="account_settings_user_info AddressSettings w-full h-auto flex flex-col gap-3">
                    <div className="flex justify-between items-center">
                        <h2>Addresses</h2>
                        {isEditing && (
                            <button 
                                onClick={handleAddNewAddress}
                                className="px-4 py-2 rounded bg-green-500 text-white"
                            >
                                + Add New Address
                            </button>
                        )}
                    </div>
                    
                    {(userData.address && userData.address.length > 0) || (editedValues.addresses && editedValues.addresses.length > 0) ? (
                        isEditing ? (
                            // Show editable addresses
                            editedValues.addresses.map((item, index) => (
                                <div key={index} className="relative">
                                    <AddressParticular
                                        address={item}
                                        isEditing={true}
                                        editedValues={editedValues}
                                        handleChange={handleChange}
                                        index={index}
                                    />
                                    {editedValues.addresses.length > 1 && (
                                        <button 
                                            onClick={() => handleRemoveAddress(index)}
                                            className="absolute top-2 right-2 text-red-500 bg-white rounded-full p-1"
                                            title="Remove address"
                                        >
                                            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                            </svg>
                                        </button>
                                    )}
                                </div>
                            ))
                        ) : (
                            // Show read-only addresses
                            userData.address.map((item, index) => (
                                <AddressParticular
                                    key={index}
                                    address={item}
                                    isEditing={false}
                                    index={index}
                                />
                            ))
                        )
                    ) : (
                        <div className="flex items-center justify-between bg-[#FAF9F8] p-4 rounded">
                            <p className="text-gray-500 italic">No addresses added yet.</p>
                            {!isEditing && (
                                <button 
                                    onClick={() => {
                                        setEditedValues(prev => ({
                                            ...prev,
                                            addresses: [{ ...emptyAddress }]
                                        }));
                                        setIsEditing(true);
                                    }}
                                    className="px-4 py-2 rounded bg-green-500 text-white"
                                >
                                    Add First Address
                                </button>
                            )}
                        </div>
                    )}
                </div>

                <div className="account_settings_user_info paymentSettings w-full h-auto flex flex-col gap-3 my-4">
                    <h2>Payment Methods</h2>
                    {userData.paymentMethods && userData.paymentMethods.length > 0 ? (
                        userData.paymentMethods.map((item, index) => (
                            <PaymentParticular
                                key={index}
                                method={item}
                            />
                        ))
                    ) : (
                        <p className="text-gray-500 italic p-2">No payment methods added yet.</p>
                    )}
                </div>

                {isEditing && (
                    <div className="mt-4 flex justify-end">
                        <button 
                            onClick={handleSubmit}
                            disabled={isLoading}
                            className="px-4 py-2 bg-green-500 text-white rounded hover:bg-green-600 disabled:bg-gray-400"
                        >
                            {isLoading ? 'Saving...' : 'Save Changes'}
                        </button>
                    </div>
                )}
            </div>
        </div>
    )
}
function Logout(){
    const Navigate = useNavigate();
    async function handleLogout(){
        try{
            const response = await axios.post(`${baseUrl}api/auth/logout` , {} , {withCredentials : true});
            // console.log(response)    
            localStorage.removeItem("accessToken")
            localStorage.removeItem("token")
            localStorage.removeItem("refreshToken")

            Navigate("/")
        }catch(error){
            console.log("error while logging out")
            console.log(error)
        }
    }
    return(
        <div className="SettingAreaDiv OrdersDiv">
            <h5>Sign out</h5>
            <button onClick={handleLogout}>Click to Sign out<i class="fa-light fa-arrow-right-from-bracket"></i></button>
        </div>
    )
}



function SectionTwo({userData , setUserData}){
    const [step , setStep ] = React.useState(null)

    return(
        <div className="SectionTwo max-w-[100vw] overflow-x-hidden">
            <div className="SettingsOptions">

                <SettingOption
                    Setting = "Orders"
                    iconClass = "fa-light fa-box"
                    step = {0}
                    setStep = {setStep}
                />
                <SettingOption
                    Setting = "Account Settings"
                    iconClass = "fa-light fa-gear"
                    step = {1}
                    setStep = {setStep}
                    userData = {userData}
                    
                />
                <SettingOption
                    Setting = "Sign-out"
                    iconClass = "fa-light fa-arrow-right-from-bracket"
                    step = {2}
                    setStep = {setStep}
                />

            </div>
            <div className="SettingsArea">
                {step === 0 &&<Orders/>}
                {step === 1 &&<AccountSettings
                    userData={userData}
                    setUserData={setUserData}
                />}
                {step === 2 &&<Logout/>}
            </div>
        </div>
    )
}

function ProfilePage(){

    const Navigate = useNavigate()
    React.useEffect(() => {
            const checkLoginStatus = async () => {
            try {
                const accessToken = localStorage.getItem("accessToken");

                const config = {
                    withCredentials: true,
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                        'Content-Type': 'application/json',
                    },
                };

                const response = await axios.get(`${baseUrl}api/auth/IsLoggedIn`, config);
            } catch (err) {
                console.error("Error while checking login status:", err.response?.data || err.message);
                Navigate("/");
            }
        };

        checkLoginStatus();
    }, []);

    const [userData , setUserData] = React.useState({})

    React.useEffect(()=>{
        const getUserData = async()=>{
            try{
                const accessToken = localStorage.getItem("accessToken");

                    const response = await axios.get(`${baseUrl}api/user/profile`, {
                    withCredentials: true,
                        headers: {
                            Authorization: `Bearer ${accessToken}`,
                            'Content-Type': 'application/json', // optional but good to include
                    },
                });


                // console.log(response?.data?.data); 
                setUserData(response?.data?.data)

            } catch (err) {
                console.error("Error while retreiving user data :", err.response?.data || err.message);
                localStorage.removeItem("accessToken")
                Navigate("/")
            }
         }

         getUserData();

    } , [])

    // console.log(userData)


    React.useEffect(() => {
        document.title = "Jutexx | Profile";
    }, []);
    return (
        <div className="profilePageDiv bg-[#faf9f8]" >
            <Navbar/>
            <div className="profilePageCenterDiv">
                <SectionOne userData = {userData}/>
                <SectionTwo userData = {userData} setUserData={setUserData}/>
            </div>
            <Footer/>
        </div>
    )
}

export default ProfilePage ;